/**
 * Pages carried over from the current console (Coordination, Talent record, Billing, Referrals, Reviews, Audit Log)
 * link to /lp-console/...; inside the new console those links must stay in it (audit 25 Sep 2026). Same page, same
 * route shape: /lp-console/talent/123 → /lp-console/staging/talent/123 when the page is showing under the staging root.
 * Since the swap (26 Sep 2026) the staging root IS /lp-console, so every link already points at the console and
 * this returns it unchanged.
 */
import { STAGING_ROOT } from './roleNav.js'

const currentPath = () => (typeof window !== 'undefined' && window.location ? window.location.pathname : '')

export function inStaging(pathname = currentPath()) {
  return pathname === STAGING_ROOT || String(pathname).startsWith(STAGING_ROOT + '/')
}

export function consoleLink(path, pathname = currentPath()) {
  const p = String(path)
  if (!inStaging(pathname) || p === STAGING_ROOT || p.startsWith(STAGING_ROOT + '/')) return p
  return p.replace(/^\/lp-console(?=\/|$|\?)/, STAGING_ROOT)
}
